import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  const location = useLocation();

  const isVenderCartaPage = location.pathname === '/quero-vender-minha-carta';

  const whatsappMessage = isVenderCartaPage
    ? 'Olá! Tenho uma carta de consórcio e gostaria de saber quanto posso receber pela venda. Podem me ajudar?'
    : 'Olá! Gostaria de saber mais sobre os consórcios da Carvalhos Consórcios.';

  const tooltipText = isVenderCartaPage
    ? 'Quero vender minha carta!'
    : 'Fale conosco agora!';

  const whatsappUrl = `https://wa.me/5511922305730?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="relative">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-3 px-4 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-lg whitespace-nowrap shadow-lg animate-fade-up">
            {tooltipText}
            <div className="absolute top-full right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
          </div>
        )}

        {/* Button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="relative flex items-center justify-center w-16 h-16 bg-green-500 hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 text-white rounded-full shadow-2xl hover:shadow-green-500/50 dark:hover:shadow-green-600/50 transition-all duration-300 hover:scale-110 cursor-pointer group"
          aria-label="Fale conosco no WhatsApp"
        >
          <i className="ri-whatsapp-line text-3xl"></i>

          {/* Notification Badge */}
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 dark:bg-red-600 rounded-full border-2 border-white dark:border-gray-900 animate-pulse"></span>

          {/* Ripple Effect */}
          <span className="absolute inset-0 rounded-full bg-green-500 dark:bg-green-600 animate-ping opacity-20"></span>
        </a>
      </div>
    </div>
  );
}